export default "__VITE_ASSET__5fabdb68__"